import BookingConfirmation from './booking-confirmation.component'

export default BookingConfirmation
